const console: Record<string, string> = {
    title: 'Console',
    script: 'Script',
    runScript: 'Run script',
};

export default console;
